import { useProgram as useProgramState } from "../ProgramContext";

export function useProgram() {
  const { program } = useProgramState();

  const phases =
    program?.phases?.filter((phase) => phase.frontend_display) || [];

  const currentPhase = phases.find((phase) => phase.status === "active");

  const invitation = program?.user_participation?.pair?.invitation;

  return { program, phases, currentPhase, invitation };
}

export default useProgram;
